<script lang="ts">
import type { TabsItem } from '#ui/types';

import { SellingMethod } from '~/apiClient';
import { type PlatformSellingMethod } from '~/types/sale.type';

/** `UTabs` emits `string | number`; this maps that back onto the enum without an unchecked cast. */
const TAB_VALUE_TO_SELLING_METHOD_MAP: Record<string, PlatformSellingMethod> = {
    [SellingMethod.Auction]: SellingMethod.Auction,
    [SellingMethod.DirectSale]: SellingMethod.DirectSale,
};

// `w-auto` overrides the theme's `w-full` so the list stays pill-sized.
const TABS_UI = {
    list: 'bg-default ring-default w-auto rounded-full shadow-lg ring-1',
    indicator: 'rounded-full',
    trigger: 'rounded-full',
    leadingIcon: 'size-5',
};
</script>

<script setup lang="ts">
// MODELS
const sellingMethod = defineModel<PlatformSellingMethod>({ required: true });

// COMPOSABLES
const { tt } = useTypedI18n();

// DATA
const items = computed<TabsItem[]>(() => [
    { value: SellingMethod.DirectSale, label: tt('search.quick.tab.directSale'), icon: 'lucide:shopping-bag' },
    { value: SellingMethod.Auction, label: tt('search.quick.tab.auction'), icon: 'lucide:gavel' },
]);

// METHODS
const onUpdateSellingMethod = (value: string | number): void => {
    const nextSellingMethod = TAB_VALUE_TO_SELLING_METHOD_MAP[String(value)];

    if (nextSellingMethod) sellingMethod.value = nextSellingMethod;
};
</script>

<template>
    <UTabs
        :model-value="sellingMethod"
        :items="items"
        variant="pill"
        size="xl"
        :content="false"
        :ui="TABS_UI"
        @update:model-value="onUpdateSellingMethod"
    />
</template>
